<template>
  <div class="header-wrapper">
    <div class="header">
      <div class="header-left">
        <img src="../../../assets/images/logo1.png" alt="">
      </div>
      <div class="header-mid">
        <div class="header-item">
          <i style="color:#7c6aa6" class="contact-icon am-icon-envelope"></i>
          <div class="item">
            <strong>lp@luanpu.com</strong>
            <span>周一 ~ 周日, 9:30 - 23:00</span>
          </div>
        </div>
        <div class="header-item">
          <i style="color:#7c6aa6" class="contact-icon am-icon-map-marker"></i>
          <div class="item">
            <strong>山东省菏泽市定陶区兴华路与站前路交叉口东300米路北</strong>
            <span>山东峦璞商贸有限公司</span>
            <!-- 导航链接 -->
<!--            <a href="https://m.amap.com/navi/?dest=115.550589,35.072499&destName=菏泽峦璞信息技术有限公司&hideRouteIcon=1&key=0633586e606d9dc1a882faa78cbeca2c" class="">
              <button type="button">导航</button>
            </a>-->
          </div>
        </div>
      </div>
      <div class="header-right">
        <a id="phone-link" href="#" class="">
          <button type="button">联系我们</button>
        </a>
      </div>
    </div>

    <div class="nav-wrapper header-default">
      <div class="nav">
        <ul class="am-nav am-nav-pills am-nav-justify">
          <li><router-link class="router" to="/">网站首页</router-link></li>
<!--          <li><router-link class="router" to="/product">产品中心</router-link></li>-->
          <li><router-link class="router" to="/example">客户案例</router-link></li>
          <li><router-link class="router" to="/news">公司动态</router-link></li>
          <li><router-link class="router" to="/about">关于我们</router-link></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import AppFunctions from "@/utils/AppFunctions";
import CryptoJS from 'crypto-js';

export default {
  name: "Header",
  components: {},
  data() {
    return {
      AppFunctions,
      encryptedPhoneNumber: "U2FsdGVkX1/cbpJDB2kaBwblbjiS1u8jcSCI5MlHs54=", // 这里填入你加密后的电话号码
      secretKey: 'wubawan1.', // 确保这个密钥与加密时使用的密钥相同
    };
  },
  methods: {
    toggleStickyHeader() {
      const scrolled = document.documentElement.scrollTop;
      if (scrolled > 100) {
        AppFunctions.addClass('.header-default', 'sticky');
      } else if (scrolled <= 100) {
        AppFunctions.removeClass('.header-default', 'sticky');
      }
    },
    createPhoneLink() {
      const decryptedPhoneNumber = CryptoJS.AES.decrypt(this.encryptedPhoneNumber, this.secretKey).toString(CryptoJS.enc.Utf8);
      const link = document.getElementById("phone-link");
      link.href = `tel:${decryptedPhoneNumber}`;

    },
  },
  created() {
    window.addEventListener('scroll', this.toggleStickyHeader);
  },
  mounted() {
    this.toggleStickyHeader();
    this.createPhoneLink();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.toggleStickyHeader);
  }
}
</script>

<style scoped>
.router.router-link-active{
	/*color: #fff;*/
	/*background-color: #0e90d2;*/
	/*border: 1px solid #0e90d2;*/
	cursor: default;
	
	color: #0e90d2;
}

</style>
